<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.phone" placeholder="手机号码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.orderNO" placeholder="订单号"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" v-on:click="get">查询</el-button>
                </el-form-item>

            </el-form>
        </el-col>

        <el-table :data="datas" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange" :row-class-name="cellClass"
                  style="width: 100%;text-align: center">

            <el-table-column type="index" width="60">
            </el-table-column>
            <el-table-column prop="phone" label="手机号码" width="160">
            </el-table-column>
            <el-table-column prop="orderNO" label="订单编号" width="180">
            </el-table-column>
            <el-table-column prop="sendTime" label="发送时间" width="200">
            </el-table-column>
            <el-table-column prop="smsContent" label="内容" style="text-align: left;color:red" min-width="205">
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>


    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    phone: '',
                    orderNO: ''
                },
                datas: [],
                total: 0,
                rowCount: 30,
                pageNO: 1,
                listLoading: false,
                sels: [],


            }
        },
        methods: {
            cellClass() {
                return 'cellClass';
            },


            handleCurrentChange(val) {
                this.pageNO = val;
                this.get();
            },


            get() {
                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };
                Object.assign(para, this.filters);
                this.listLoading = true;
                NProgress.start();
                let url = 'smsLog/getPage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.datas = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },


            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {
            this.get();

        },
        activated: function () {

        }
    }

</script>


<style scoped>
    .cellClass {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// smsLog.vue?2635dda4